<template>
  <div>
    <b-modal
      v-model="modalShow"
      title="รายการสินค้า"
      hide-footer
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
      header-class="bg-purple2"
    >
      <template #modal-header>
        <div class="w-100">
          <strong class="title-modal">รายการสินค้า</strong>
          <b-icon
            icon="x-circle-fill"
            class="float-right pointer"
            @click="modalShow = false"
          ></b-icon>
        </div>
      </template>
      <div class="filter-panel">
        <b-row>
          <b-col sm="9" class="pr-0">
            <b-input-group class="panel-input-serach">
              <b-form-input
                class="search-input border-input"
                placeholder="ค้นหาชุดแบทช์"
                @keyup.enter="getBatchList()"
                v-model="filter.SearchBatchNo"
              ></b-form-input>
              <b-input-group-prepend>
                <span class="icon-input m-auto pr-2">
                  <font-awesome-icon
                    icon="search"
                    title="View"
                    @click="getBatchList"
                  />
                </span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
          <b-col sm="3" class="pl-0">
            <router-link to="/batch/create-batch/0" id="createPromotionBtn">
              <b-button class="purple-btn ml-2">
                <font-awesome-icon
                  icon="plus-circle"
                  title="create-btn"
                  class="mr-0 mr-sm-1"
                />
                <span class="d-none d-sm-inline">สร้างแบทช์ใหม่</span>
              </b-button>
            </router-link>
          </b-col>
        </b-row>
      </div>
      <b-row class="mt-2">
        <b-col sm="12">
          <b-table
            responsive
            striped
            sticky-header
            :thStyle="tableHeaderStyle"
            class="mt-2 text-center table-list"
            :fields="fieldsSelectProduct"
            :items="batchList"
            :busy="isBusy"
            show-empty
            empty-text="ไม่พบข้อมูล"
          >
            <template v-slot:cell(id)="data">
              <b-form-group class="cb-table">
                <b-form-checkbox
                  :value="data.item.id"
                  v-model="batchSelect"
                  @change="selectProductTable($event)"
                ></b-form-checkbox>
              </b-form-group>
            </template>
            <template v-slot:cell(batchNo)="data">
              <p class="m-0 text-left" v-if="data.item.batchNo">
                {{ data.item.batchNo }}
              </p>
              <p v-else class="m-0">-</p>
            </template>
            <template v-slot:cell(createdTime)="data">
              <div class="date-text table-row" v-if="data.item.createdTime">
                {{ new Date(data.item.createdTime) | moment($formatDateTime) }}
              </div>
              <div class="date-text" v-else><p class="m-0">-</p></div>
            </template>
            <template v-slot:cell(orderQuantity)="data">
              <p class="m-0" v-if="data.item.orderQuantity">
                {{ data.item.orderQuantity | numeral("0,0") }}
              </p>
              <p v-else class="m-0">-</p>
            </template>
            <template v-slot:cell(itemQuantity)="data">
              <p class="m-0" v-if="data.item.itemQuantity">
                {{ data.item.itemQuantity | numeral("0,0") }}
              </p>
              <p v-else class="m-0">-</p>
            </template>

            <template v-slot:table-busy>
              <div class="text-center text-black my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong class="ml-2">Loading...</strong>
              </div>
            </template>
          </b-table>
        </b-col>
        <b-col sm="6">
          <b-button class="btn-cancel-modal" @click="hide">ยกเลิก</b-button>
        </b-col>
        <b-col sm="6" class="text-right">
          <b-button class="btn-submit-modal" @click="submitMoveOrder"
            >ยืนยัน / ต่อไป</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import InputSelect from "@/components/inputs/InputSelect";
export default {
  name: "MoveOrder",
  components: {
    InputSelect,
  },
  props: {
    // promotionProductIdList: {
    //   type: Array,
    //   isRequired: true,
    // },
  },
  data() {
    return {
      modalShow: false,
      isBusy: false,
      fieldsSelectProduct: [
        {
          key: "id",
          label: "",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "8%",
          },
        },
        {
          key: "batchNo",
          label: "หมายเลขชุดแบทช์",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "35%",
          },
        },
        {
          key: "createdTime",
          label: "วันที่สร้าง",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "15%",
          },
        },
        {
          key: "orderQuantity",
          label: "จำนวนรายการสั่งซื้อ",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "25%",
          },
        },
        {
          key: "itemQuantity",
          label: "จำนวนสินค้า",
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            "background-color": "#d1d0e6 !important",
            width: "17%",
          },
        },
      ],
      batchList: [],
      batchSelect: [],
      filter: {
        SearchBatchNo: "",
      },
      tableHeaderStyle: {
        "background-color": "#d1d0e6 !important",
      },
    };
  },
  methods: {
    show() {
      this.getBatchList();
      this.modalShow = true;
    },
    hide() {
      this.filter = {
        SearchBatchNo: "",
      };
      this.modalShow = false;
    },
    getBatchList() {
      this.isBusy = true;
      this.batchSelect = [];
      this.axios
        .post(`${this.$baseUrl}/Batch/ListMoveBatch`, this.filter)
        .then((data) => {
          if (data.result == 1) {
            this.batchList = data.detail;
            this.batchList.forEach((e, index) => {
              e.id = index;
            });
          }
          this.isBusy = false;
        });
    },
    submitMoveOrder() {
      this.$emit("openConfirmModal", this.batchSelect);
      this.hide();
    },
    selectProductTable(value) {
      if (value != null) {
        this.batchSelect = [value];
      } else {
        this.batchSelect = [];
      }
    },
  },
};
</script>

<style scoped>
.border-input {
  border: none;
}
.text-gray {
  color: #bcbcbc;
}
.btn-submit-modal {
  width: 150px;
  color: #ffffff;
  background-color: #8f20c6;
  border-radius: 2px;
}
.btn-cancel-modal {
  width: 150px;
  color: #ffffff;
  background-color: #575757;
  border-radius: 2px;
}
.purple-btn {
  background-color: #ffffff;
  color: #8a44c3;
  border: 1px solid #8a44c3;
  width: 95%;
  min-height: 40px;
  min-width: 150px;
  transition: 0.3s;
}
.purple-btn:hover {
  background: #8a44c3;
  color: #ffffff;
  border: #8a44c3 solid 1px;
}
.cb-table {
  position: relative;
  margin-left: 15px;
  padding-top: 15px;
}
</style>
